<div class="app-wrapper" *ngIf="access">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section">
        <div class="app-main">
            <header>
                <div class="data-header">
                  <core-title-section
                    [title]="'User groups'"
                    [description]="'Permission groups and user assignment.'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                  <div class="button-settings-add">
                    <core-helpers-navigation-three-dots-menu
                      [menu]="menu"
                      (action)="onMenuClick($event)"
                    ></core-helpers-navigation-three-dots-menu>
                  </div>
                </div>
              <!-- <div class="instructions">
                  <a (click)="showInstructions = !showInstructions" class="trigger" [ngClass]="{'opened' : showInstructions}"><em>How does this work?</em></a>
                  <ol *ngIf="showInstructions">
                    <li>Create a <strong>NEW GROUP</strong> and assign users.</li>
                    <li>Select a group to show the <strong>USER MEMBERS</strong>.</li>
                    <li><strong>DEACTIVATE</strong> old/unnecessary groups.</li>
                    <li><strong>CHANGE</strong> group assignment for users.</li>
                  </ol>
                </div>
                -->
            </header>

            <settings-groups-add-form
              [hidden]="!showForm"
              (cancel)="showForm=false"
              (submit)="showForm=false"
            ></settings-groups-add-form>

            <settings-groups-list
              (select)="selectedGroup=$event"
            ></settings-groups-list>

            <settings-groups-group-users
              *ngIf="selectedGroup!=null && selectedGroup.active"
              [group]="selectedGroup"
            ></settings-groups-group-users>

            <footer>
                  <div class="button-tool">
                  </div>
            </footer>
        </div>
    </section>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
